const hoursToRevalidateSensitiveActions = 1.0;
const AUTH_CODE_EXPIRATION_MINUTES = 10;
const locales = ['en-US', 'fr-FR', 'ja-JP'];

/**
 * Cuantos datasets sirve `GET /datasets` por pagina.
 *
 * Vive aca porque es el mismo numero de los dos lados: la lista lo pide y la
 * API lo valida como default y como maximo.
 *
 * Que sea tambien el techo no es cosmetico. La pagina define la lista de
 * `datasetId` con la que `getLastRunByDataset` va a buscar el ultimo run de
 * cada uno, y el `IN` de esa query se traduce en un span de indice por id -30
 * ids, 30 spans, confirmado con `EXPLAIN` contra produccion-. Sin tope, el
 * `limit` de la request decide cuan grande es ese span list.
 */
const DATASETS_PAGE_SIZE = 30;

const { NOTIFICATION_LIMITS } = require('./notificationLimits');

module.exports = {
  hoursToRevalidateSensitiveActions,
  AUTH_CODE_EXPIRATION_MINUTES,
  locales,
  DATASETS_PAGE_SIZE,
  NOTIFICATION_LIMITS,
};
